import { Checkbox, ListItemText } from "@material-ui/core";
import { BundleContentTypeEnum } from "../../../../generated/graphql";
import { FilterSelect, FilterMenuItem } from "../../styles";
import { experiments } from "../SelectModelType";

interface ContentTypeFilterProps {
  label: string;
  selectedValues: BundleContentTypeEnum[];
  onChange: (values: BundleContentTypeEnum[]) => void;
}

const allTypes = experiments.map(({ type }) => type);

export const ContentTypeFilter = ({
  label,
  selectedValues,
  onChange,
}: ContentTypeFilterProps) => (
  <FilterSelect
    multiple
    displayEmpty
    variant="outlined"
    value={selectedValues.length === 0 ? allTypes : selectedValues}
    renderValue={() => label}
    onClick={(e) => e.stopPropagation()}
    onChange={(e) => {
      const values = e.target.value as BundleContentTypeEnum[];
      onChange(values.length === allTypes.length ? [] : values);
    }}
  >
    {experiments.map(({ type, text }) => (
      <FilterMenuItem key={type} value={type}>
        <Checkbox checked={selectedValues.length === 0 || selectedValues.includes(type)} />
        <ListItemText primary={text} />
      </FilterMenuItem>
    ))}
  </FilterSelect>
);
